import apiClient from './apiClient'

const getSms = (tenant, projectId, onlyThisProject, skip, take, search) => {
  const params = {
    onlyThisProject,
    skip,
    take,
    keyword: search
  }
  return apiClient.get(`/${tenant}/Sms/${projectId}`, { params })
}

const getThreadSms = (tenant, projectId, threadId, onlyThisProject, skip, take, search) => {
  const params = {
    onlyThisProject,
    skip,
    take,
    keyword: search
  }
  return apiClient.get(`/${tenant}/Sms/${projectId}/thread/${threadId}`, { params })
}

const getRelations = (tenant, { id }) => {
  return apiClient.get(`/${tenant}/Sms/${id}/Relations`)
}

const createSms = (tenant, projectId, sms) => {
  return apiClient.post(`/${tenant}/Sms/${projectId}`, sms)
}

const createThreadSms = (tenant, projectId, threadId, sms) => {
  return apiClient.post(`/${tenant}/Sms/${projectId}/thread/${threadId}`, sms)
}

const reSendSms = (tenant, projectId, threadId, sms) => {
  return apiClient.post(`/${tenant}/Sms/${projectId}/thread/${threadId}/ReSend`, sms)
}

const putSmsRead = (tenant, projectId, smsId) => {
  return apiClient.put(`/${tenant}/Sms/${projectId}/${smsId}/read`)
}

const deleteSms = (tenant, { id, projectId }) => {
  return apiClient.delete(`/${tenant}/Sms/${projectId}/${id}`)
}

export default {
  getSms,
  getThreadSms,
  getRelations,
  createSms,
  createThreadSms,
  reSendSms,
  putSmsRead,
  deleteSms
}
